import React from 'react';
import { Dropdown, Button, Flex, Typography } from 'antd';
import { LayoutOutlined, DownOutlined, PlusOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import DealsTable from "components/Deal/DealsTable";
import DealsKanban from "components/Deal/DealsKanban";
import useUrlFilters from 'hooks/useUrlFilters';

// The view is in the URL so a shared link to a filtered list opens the list,
// not the kanban (the list's own filters are in the URL too).
const URL_FILTERS = {
    view: { type: 'string', default: 'kanban' }, // 'list', 'kanban', 'split'
};

const Deals = () => {
    const navigate = useNavigate();
    const [filters, setFilters] = useUrlFilters(URL_FILTERS);
    const currentView = filters.view;
    const setCurrentView = (view) => setFilters({ view }, { replace: false });

    const viewMenuItems = [
        {
            key: 'list',
            label: 'List View',
            onClick: () => setCurrentView('list'),
        },
        {
            key: 'kanban',
            label: 'Kanban View',
            onClick: () => setCurrentView('kanban'),
        },
    ];

    const renderView = () => {
        switch (currentView) {
            case 'kanban':
                return <DealsKanban />;
            case 'split':
                // TODO: Implement split view
                return <DealsTable hideHeader={true} />;
            case 'list':
            default:
                return <DealsTable hideHeader={true} />;
        }
    };

    return (
        <div style={{ padding: '20px' }}>
            <Flex justify="space-between" align="center" style={{ marginBottom: 16 }}>
                <Typography.Title level={3}>All Deals</Typography.Title>
                <Flex gap="middle">
                    <Dropdown menu={{ items: viewMenuItems, selectedKeys: [currentView] }} trigger={['click']}>
                        <Button icon={<LayoutOutlined />}>
                            {currentView === 'list' ? 'List View' : currentView === 'kanban' ? 'Kanban View' : 'Split View'}
                            <DownOutlined />
                        </Button>
                    </Dropdown>
                    <Button
                        type="primary"
                        icon={<PlusOutlined />}
                        onClick={() => navigate('/deals/new')}
                    >
                        Create Deal
                    </Button>
                </Flex>
            </Flex>
            {renderView()}
        </div>
    );
}

export default Deals;
